<template>
  <div class="row mb-10">
    <div class="col-sm-6 col-md-4 d-flex align-center">
      <EducationSystemSelect
        @setEducationSystem="parameters.education_system_id = $event"
      />
    </div>
    <div class="col-sm-6 col-md-4 d-flex align-center">
      <EducationStageSelect
        :education-system-id="parameters.education_system_id"
        @setEducationStage="parameters.education_stage_id = $event"
      />
    </div>
    <div class="col-sm-6 col-md-4 d-flex align-center">
      <GradeSelect
        :education-stage-id="parameters.education_stage_id"
        @setGrade="parameters.grade_id = $event"
      />
    </div>
    <div class="col-sm-6 col-md-4 d-flex align-center">
      <GradeVolumeSelect
        :grade-id="parameters.grade_id"
        @setGradeVolume="parameters.grade_volume_id = $event"
      />
    </div>
    <div class="col-sm-6 col-md-4 d-flex align-center">
      <GradeSubjectSelect
        :grade-id="parameters.grade_id"
        @setGradeSubject="parameters.grade_subject_id = $event"
      />
    </div>
    <div class="col-sm-6 col-md-4 d-flex align-center">
      <v-select
        v-model="parameters.is_teacher_material"
        class="px-2"
        :items="materialTarget"
        item-text="name"
        item-value="value"
        label="Material do:"
      >
        <template
          v-if="parameters.is_teacher_material !== null"
          #append
        >
          <v-btn
            color="primary"
            text
            @click="parameters.is_teacher_material = null"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-select>
    </div>
    <div class="col-sm-6 col-md-4 d-flex align-center">
      <v-select
        v-model="parameters.publishing_year"
        class="px-2"
        :items="years"
        item-text="name"
        item-value="value"
        label="Ano de publicação"
      >
        <template
          v-if="parameters.publishing_year !== null"
          #append
        >
          <v-btn
            color="primary"
            text
            @click="parameters.publishing_year = null"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-select>
    </div>
    <div class="col-sm-6 col-md-4 d-flex align-center">
      <v-select
        v-model="parameters.type"
        class="px-2"
        :items="types"
        item-text="name"
        item-value="id"
        label="Tipo"
      >
        <template
          v-if="parameters.type !== null"
          #append
        >
          <v-btn
            color="primary"
            text
            @click="parameters.type = null"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-select>
    </div>

    <div class="col-sm-6 col-md-4 d-flex align-center justify-end">
      <v-btn
        :disabled="hasParameters"
        depressed
        class="float-right"
        @click="setParameters()"
      >
        <v-icon left>
          mdi-magnify
        </v-icon>
        Aplicar filtros
      </v-btn>
    </div>
  </div>
</template>

<script>
import { listTypes } from '@/enums/materialTypes.js'
import EducationSystemSelect from '@/components/contents/EducationSystemSelect.vue'
import EducationStageSelect from '@/components/contents/EducationStageSelect.vue'
import GradeSelect from '@/components/contents/GradeSelect.vue'
import GradeVolumeSelect from '@/components/contents/GradeVolumeSelect.vue'
import GradeSubjectSelect from '@/components/contents/GradeSubjectSelect.vue'

export default {
  components: {
    EducationSystemSelect,
    EducationStageSelect,
    GradeSelect,
    GradeVolumeSelect,
    GradeSubjectSelect
  },

  data: () => ({
    parameters: {
      education_system_id: null,
      education_stage_id: null,
      grade_id: null,
      grade_volume_id: null,
      grade_subject_id: null,
      publishing_year: null,
      type: null,
      is_teacher_material: null
    },
    types: [],
    materialTarget: [
      {
        value: false,
        name: 'Aluno'
      }, {
        value: true,
        name: 'Professor'
      }
    ],
    years: [
      new Date().getFullYear() + 1,
      new Date().getFullYear(),
      new Date().getFullYear() - 1,
      new Date().getFullYear() - 2
    ]
  }),
  watch: {
  },
  computed: {
    hasParameters () {
      return Object.entries(this.parameters).filter(([_, value]) => value !== null).length === 0
    }
  },

  async created () {
    this.types = listTypes()
  },

  methods: {
    listTypes,

    setParameters () {
      if (this.hasParameters.is_teacher_material === true) {
        this.hasParameters.is_teacher_material = 1
      }
      if (this.hasParameters.is_teacher_material === false) {
        this.hasParameters.is_teacher_material = 0
      }
      const parameters = this.buildQuery()
      this.$emit('setParameters', parameters)
    },

    buildQuery () {
      return Object.entries(this.parameters)
        .filter(([_, value]) => value !== null)
        .map(([key, value]) => {
          const normalizedValue =
            value === true ? 1 : value === false ? 0 : value

          return `&${encodeURIComponent(key)}=${encodeURIComponent(normalizedValue)}`
        })
        .join('')
    }
  }
}
</script>
